export default __webpack_public_path__ + "static/media/upload-icon.702edd16.svg";